<template>
  <div>
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div class="content">
      <i class="iconfont">&#xe62d;</i>
      <p>请输入支付密码</p>
    </div>
    <div class="input">
      <input type="password" v-model="password">
    </div>
    <button @click="handlePayClick">确定</button>
  </div>
</template>

<script>
export default {
  name: 'VerifyMess',
  data () {
    return {
      password: ''
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handlePayClick () {
      this.axios.get('/ApiOrderPay/Pay', {
        params: {
          oids: decodeURIComponent([this.$route.query.id]),
          paypassword: this.password
        }
      }).then(this.handlePaySuccClick)
        .catch(this.handlePayFailClick)
    },
    handlePaySuccClick (res) {
      res = res.data
      if (res.okInfo === 'succeed') {
        alert('支付成功')
        this.$router.push({
          path: '/me'
        })
      } else {
        // console.log(res.errorInfo)
        alert(res.errorInfo)
      }
    },
    handlePayFailClick (err) {
      alert(err)
      // console.log(err)
    }
  }
}
</script>

<style scoped>
.header{ padding: 10px 15px;}
.header .iconfont{ font-size: 25px;}
.content{ display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 65px 0; padding-bottom: 30px;}
.content .iconfont{ font-size: 60px; color: #999999;}
.content p{ font-size: 16px; margin-top: 10px;}
.input input{ border: 2px solid #e5e5e5; width: 60%; display: block; margin: 0 auto; height: 40px; line-height: 40px;}
button{ width: 80%; display: block; margin: 20px auto; height: 40px; line-height: 40px; background: #f00; color: #fff;}
</style>



// WEBPACK FOOTER //
// src/pages/identify_verify/components/Mess.vue